import {invalidateSecurityCredentials} from 'modules/store/securityCredentials';

const SET_ACCOUNT_CREDENTIAL = 'SET_ACCOUNT_CREDENTIAL';

const _getInitialState = () => ({
    account: null
});

export const invalidateMyCredentials = () => dispatch => {
    dispatch(invalidateSecurityCredentials());
};

export const setAccountCredential = account => ({
    type: SET_ACCOUNT_CREDENTIAL,
    account
});

export const reducer = (state = _getInitialState(), action = {}) => {
    switch (action.type) {
    case SET_ACCOUNT_CREDENTIAL:
        return {
            ...state,
            account: action.account
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/userCredentials.js